import AddIcon from '@mui/icons-material/Add';
import { Fab, Grid, Tooltip, Typography } from '@mui/material';
import { ReactElement, useEffect, useState } from 'react';
import { AddEditSessionDialog } from '../Components/AddEditSessionDialog';
import { theme } from '../Mui/Theme';
import { auth } from '../firebase/firebase';

interface sessionsCardProps {
    title: string;
    children: ReactElement | ReactElement[] | string;
}

export const SessionsCard: React.FC<sessionsCardProps> = ({
    title,
    children,
}) => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [openAddSessionDialog, setOpenAddSessionDialog] = useState(false);

    useEffect(() => {
        auth.currentUser?.getIdTokenResult().then((authTokenResult) => {
            if (authTokenResult.claims.admin) {
                setIsAdmin(true);
            }
        });
    }, []);

    return (
        <Grid
            container
            sx={{
                background: theme.palette.primary.dark,
                marginTop: '50px',
                borderRadius: '10px',
                height: '75vh',
                position: 'relative',
                minWidth: '100%',
            }}
            direction="column"
            wrap="nowrap"
        >
            {isAdmin && (
                <Tooltip title="Vytvořit novou lekci">
                    <Fab
                        color="secondary"
                        sx={{
                            position: 'absolute',
                            margin: '15px',
                            top: '0',
                            right: '0',
                        }}
                        size="small"
                        onClick={() => setOpenAddSessionDialog(true)}
                    >
                        <AddIcon />
                    </Fab>
                </Tooltip>
            )}

            <Typography
                sx={{ padding: '15px', fontWeight: 'bold' }}
                variant="h4"
            >
                {title}
            </Typography>
            <Grid
                item
                container
                sx={{ overflowY: 'auto' }}
                direction="column"
                alignItems="center"
                wrap="nowrap"
            >
                {children}
            </Grid>
            {isAdmin && (
                <AddEditSessionDialog
                    open={openAddSessionDialog}
                    close={() => setOpenAddSessionDialog(false)}
                    edit={false}
                />
            )}
        </Grid>
    );
};
